import * as React from 'react';
import { compose, defaultProps, pure } from 'recompose';
import { createStyles, withStyles } from '@material-ui/styles';
import TooltipMUI from '@material-ui/core/Tooltip';
const styles = (theme) => createStyles({
    tooltip: {
        padding: 10,
        borderRadius: theme.common.borderRadius.default,
        backgroundColor: theme.color.primary.light,
        color: theme.color.font.dark,
        lineHeight: theme.font.lineHeight.mediumBig,
        boxShadow: theme.common.shadow.default,
        opacity: 1,
        textAlign: 'center',
        fontSize: theme.font.size.medium,
    },
});
const Tooltip = (props) => {
    const { classes, children, testId = 'Tooltip', arrow, disableFocusListener, disableHoverListener, disableTouchListener, enterDelay, enterNextDelay, enterTouchDelay, id, interactive, leaveDelay, leaveTouchDelay, onClose, onOpen, open, placement, PopperComponent, PopperProps, title, TransitionComponent, TransitionProps, } = props;
    return (React.createElement(TooltipMUI, { classes: { tooltip: classes.tooltip }, "data-testid": testId, arrow: arrow, disableFocusListener: disableFocusListener, disableHoverListener: disableHoverListener, disableTouchListener: disableTouchListener, enterDelay: enterDelay, enterNextDelay: enterNextDelay, enterTouchDelay: enterTouchDelay, id: id, interactive: interactive, leaveDelay: leaveDelay, leaveTouchDelay: leaveTouchDelay, onClose: onClose, onOpen: onOpen, open: open, placement: placement, PopperComponent: PopperComponent, PopperProps: PopperProps, title: title, TransitionComponent: TransitionComponent, TransitionProps: TransitionProps }, children));
};
const ComposedTooltip = compose(withStyles(styles, { withTheme: true }), pure, defaultProps({
    placement: 'top',
}))(Tooltip);
ComposedTooltip.displayName = 'Tooltip';
export default ComposedTooltip;
//# sourceMappingURL=Tooltip.js.map